import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import { ValueFieldData, RequiredValidator } from 'lib/form/value-field-data';
import FormView from 'lib/form/form-view';
import { Form, Field } from 'lib/form/form';

import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import Styled from 'styled';

import defaultStyles from './create-edit-review-view.scss';

export class CreateEditReplyForm extends Form {
    constructor(options: { handleSubmit: any; message?: string }) {
        const { message = '' } = options;
        super({
            ...options,
            field: {
                message: new Field({
                    data: new ValueFieldData({
                        value: message,
                        validators: [new RequiredValidator()],
                    }),
                }),
            },
        });
    }
}

export interface Props {
    styles: typeof defaultStyles;
    form: CreateEditReplyForm;
    innerRef: any;
}

@withStackViewForm({
    hideAction: true,
    title: <FormattedMessage id='REPLY_THE_REVIEW' values={{ gender: true }} />,
})
@observer
class CreateEditReplyView extends React.Component<Props> {
    customSubmit = () => {
        return this.props.form.submit();
    };

    render() {
        const { form } = this.props;
        const { valid, dirty } = form;

        const styles = this.props.styles!;

        return (
            <div className={styles.wrapper}>
                <FormView form={form} submitOnEnter={false} submit={this.customSubmit}>
                    <div className={styles.fieldWrapper} key='message'>
                        <TextAreaView field={form.field.get('message')} type='text' id='message' emojify={false} />
                    </div>
                    <div className={styles.submitButtonWrapper}>
                        <SubmitButtonView disabled={!(valid && dirty)} onClick={this.customSubmit}>
                            <span className={styles.submitButton}>
                                <FormattedMessage id='BUTTON_LABEL_SAVE_REPLY' />
                            </span>
                        </SubmitButtonView>
                    </div>
                </FormView>
            </div>
        );
    }
}

export default Styled(defaultStyles)(CreateEditReplyView);
